'use strict';

/** trieda sluziaca ako nositel informacii o studijnych programoch podprogramu -
 * stavoch ich dokumentov v roznych jazykoch */
export class StudijneProgramyStavPreJazyk {

	jazyk: string;
	studProgramyNeeditovatelnyStav: string[];
	studProgramyStavUzavretaVerziaKdeNechcemNovuVerziuVariant: string[];

}
